module.exports = __webpack_public_path__ + "img/logo.266a0932.gif";